import React, { FunctionComponent } from 'react';
import { Card, CardContent, SxProps, Typography } from '@mui/material';

import { useAppSelector } from '../../../../hooks';
import { getAuthState } from '../../../../store/AuthSlice';
import {
  checkUserPermission,
  getFormatedDurationByMinutes,
} from '../../../../helper';
import { getTenantsState } from '../../../../store/V2/TenantsSlice';
import { USER_PERMISSION_INDIVIDUALS } from '../../../../store/V2/RolesSlice';

const containerStyles: SxProps = {
  backgroundColor: '#475569',
  color: '#F8FAFC',
  borderRadius: '18px',
};

const CreditViewer: FunctionComponent = () => {
  // Store
  const authState = useAppSelector(getAuthState);
  const tenantState = useAppSelector(getTenantsState);

  const { user: authUser } = authState;
  const { appTenant } = tenantState;

  if (
    authUser &&
    'remainingTime' in authUser &&
    checkUserPermission({
      authUser,
      tenant: appTenant,
      permissions: {
        headerContents: [
          USER_PERMISSION_INDIVIDUALS.HEADER_CONTENTS_CREDITS_VIEWER,
        ],
      },
    })
  ) {
    return (
      <Card elevation={0} sx={containerStyles}>
        <CardContent style={{ padding: '7px 18px' }}>
          <Typography fontWeight={600} fontSize="14px">
            {getFormatedDurationByMinutes({
              minutes: authUser.remainingTime || 0,
            })}
          </Typography>
        </CardContent>
      </Card>
    );
  }

  return null;
};

export default CreditViewer;
